import { Briefcase, RefreshCw, Target, ClipboardList } from "lucide-react";

const profiles = [
  {
    icon: Briefcase,
    title: "Salarié en questionnement",
    desc: "Vous sentez que votre poste ne vous correspond plus",
  },
  {
    icon: RefreshCw,
    title: "En reconversion professionnelle",
    desc: "Vous voulez changer de secteur sans prendre de risques",
  },
  {
    icon: Target,
    title: "Cadre ou manager",
    desc: "Vous cherchez à repositionner votre carrière",
  },
  {
    icon: ClipboardList,
    title: "Demandeur d'emploi",
    desc: "Vous voulez clarifier votre projet avant de postuler",
  },
];

const ForWhoSection = () => (
  <section className="section-padding bg-muted/50">
    <div className="container mx-auto text-center">
      <h2 className="mb-4 text-3xl font-extrabold md:text-4xl">
        Le Bilan de Compétences est fait pour vous si...
      </h2>
      <div className="mx-auto mt-10 grid max-w-4xl gap-6 sm:grid-cols-2">
        {profiles.map((p) => (
          <div
            key={p.title}
            className="flex items-start gap-4 rounded-2xl border border-border bg-card p-6 text-left shadow-sm transition-all hover:-translate-y-1 hover:shadow-md"
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <p.icon className="h-6 w-6" />
            </div>
            <div>
              <h3 className="mb-1 font-bold">{p.title}</h3>
              <p className="text-sm text-muted-foreground">{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ForWhoSection;
